import { PagePending } from "@/components/ui/PagePending";
import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/members/$memberId/new-purchase")({
  pendingComponent: PagePending,
  beforeLoad: () => ({
    breadcrumb: "New Purchase",
  }),
  component: lazyRouteComponent(() => import("./+NewPurchasePage")),
  head: () => ({ meta: seo({ title: "Create Retrospective Purchase" }) }),
});
